import React from 'react';
import ListFlowPanel from '~/components/ListFlow/Elements/ListFlowPanel';
import ListFlowAcceptOffersRow from '~/components/ListFlow/PriceSection/ListFlowAcceptOffersRow';
import ListFlowAuctionRow from '~/components/ListFlow/PriceSection/ListFlowAuctionRow';
import useHasFeature from '~/hooks/useHasFeature';

interface Props {}

const ListFlowAdvancedPricingOptions: React.FC<Props> = () => {
  const auctionsEnabled = useHasFeature('auctions_enabled');
  const acceptsOffersEnabled = useHasFeature('show_accept_offer_toggle');
  const fixedPricesEnabled = useHasFeature('fixed_price_listings');

  const canToggleOffers = fixedPricesEnabled || acceptsOffersEnabled;

  if (!auctionsEnabled && !canToggleOffers) {
    return null;
  }

  return (
    <ListFlowPanel title="Advanced Pricing Options">
      {auctionsEnabled && <ListFlowAuctionRow />}
      {canToggleOffers && <ListFlowAcceptOffersRow />}
    </ListFlowPanel>
  );
};

export default ListFlowAdvancedPricingOptions;
